/**
 * @file Renders the Backstage settings page for the current user's own profile.
 */
import React, { useEffect, useState } from "react";
import { useAppContext } from "@components/AppContext";
import { W0, W1 } from "@components/Constants";

import MyProfile from "@components/MyProfile";
import { type AppContext } from "@components/AppContext/types";

/**
 * Renders the Backstage settings page for the current user's own profile.
 */
const SettingsMyProfilePage = (): JSX.Element => {
  const {
    identity,
    updateIdentityMobile,
    updateIdentityIs2FaEnabled,
  } = useAppContext() as AppContext & {
    updateIdentityMobile?: (mobile: string) => void;
    updateIdentityIs2FaEnabled?: (is2FaEnabled: boolean) => void;
  };

  const givenName = identity?.givenName;
  const familyName = identity?.familyName;
  const email = identity?.email;
  const mobile = identity?.mobile;
  const [ is2FaEnabled, setIs2FaEnabled ] = useState(identity?.is2FaEnabled);

  const fullName = `${givenName || ""} ${familyName || ""}`.trim();
  const style = {
    padding: `${W1}px ${W1 + W0}px`,
  };
  /**
   * Updates the local and the shared 2FA state after the user switches it.
   */
  const onSuccessSwitch2Fa = async (shouldEnable: boolean) => {
    setIs2FaEnabled(shouldEnable);
    updateIdentityIs2FaEnabled?.(shouldEnable);
  };
  /**
   * Updates the shared identity mobile number after the user changes it.
   */
  const onSuccessUpdateMobile = (updatedMobile: string) => {
    updateIdentityMobile?.(updatedMobile);
  };

  useEffect(() => {
    setIs2FaEnabled(identity?.is2FaEnabled);
  }, [ identity?.is2FaEnabled ]);

  return (
    <div style={style}>
      <MyProfile
        userId={identity?.id || ""}
        name={fullName}
        email={email}
        mobile={mobile}
        is2FaEnabled={is2FaEnabled}
        onSuccessUpdateMobile={onSuccessUpdateMobile}
        onSuccessSwitch2Fa={onSuccessSwitch2Fa}
      />
    </div>
  );
};

export default SettingsMyProfilePage;
